module.exports = __webpack_public_path__ + "static/media/color.4c1bcb53.svg";